import { googleAnalyticsConfig } from '../config'

// ----------------------------------------------------------------------

const setup = (
  targetId: string,
  config?: Gtag.CustomParams | Gtag.ControlParams | Gtag.EventParams
) => {
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  if (!window.gtag) {
    return
  }
  window.gtag('config', targetId, config)
}

const setupEvent = (
  targetId: string,
  config?: Gtag.CustomParams | Gtag.ControlParams | Gtag.EventParams
) => {
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  if (!window.gtag) {
    return
  }
  window.gtag('event', targetId, config)
}

const setGtag = (config: Gtag.CustomParams) => {
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  if (!window.gtag) {
    return
  }
  window.gtag('set', config)
}

const setGtagTarget = (targetId: string, config: Gtag.CustomParams) => {
  if (process.env.NODE_ENV !== 'production') {
    return
  }
  if (!window.gtag) {
    return
  }
  window.gtag('set', targetId, config)
}

export const normalizeFarmRole = (role?: string | null): string | undefined => {
  if (!role) return undefined
  const withUnderscores = role.replace(/([a-z0-9])([A-Z])/g, '$1_$2')
  return withUnderscores.toLowerCase()
}

// DOF-1192 fix: role.name/user_role.name are Thai display text at runtime
// (e.g. 'รองเจ้าของฟาร์ม' — matches modules/member/constants.ts's RoleName
// enum values), not the English CamelCase normalizeFarmRole() assumes —
// normalizeFarmRole() is a no-op on Thai script. Used for both the
// `farm_role` user property and the `member_invited.role` event param, so
// the two stay consistent. Only the 3 known preset roles are named; a
// user-created custom role reports as 'custom' rather than leaking its
// free-text name (PDPA — never send free text).
export const normalizeRoleForAnalytics = (roleName?: string | null): string | undefined => {
  if (!roleName) return undefined
  switch (roleName) {
    case 'เจ้าของฟาร์ม':
      return 'primary_owner'
    case 'รองเจ้าของฟาร์ม':
      return 'secondary_owner'
    case 'admin':
      return 'admin'
    default:
      return 'custom'
  }
}

// DOF-1176: maps the app's Thai species names to the shared cross-platform
// `species` event param values (`shrimp`/`fish`/`shellfish`), mirroring
// dofarm-mobile's normalizeSpeciesName. Falls back to the raw name
// (lowercased) for anything unrecognized rather than dropping it.
export const normalizeSpeciesName = (thaiName?: string | null): string | undefined => {
  if (!thaiName) return undefined
  switch (thaiName) {
    case 'กุ้ง':
      return 'shrimp'
    case 'ปลา':
      return 'fish'
    case 'หอย':
      return 'shellfish'
    default:
      return thaiName.toLowerCase()
  }
}

const track = {
  pageview: (props?: Gtag.CustomParams | Gtag.ControlParams | Gtag.EventParams) => {
    setup(googleAnalyticsConfig || '', props)
  },
  event: (type: string, props?: Gtag.CustomParams | Gtag.ControlParams | Gtag.EventParams) => {
    setupEvent(type, props)
  },
  setUserId: (userId: string | null) => {
    setGtag({ user_id: userId ?? undefined })
  },
  setUserProperty: (name: string, value: string | null) => {
    setGtagTarget('user_properties', { [name]: value ?? undefined })
  },
}

export default track
